import { keyframes } from '@emotion/core'
import { Chip, fade, makeStyles } from '@material-ui/core'
import React from 'react'
import { colors } from 'theme'

const pulsingShadow = keyframes`
  0%{
    box-shadow: 0 0 0 0 ${fade(colors.aquaMain90, 0.7)}, 0 0 0 0 ${fade(
  colors.aquaMain90,
  0.7,
)};
  }
  40%{
    box-shadow: 0 0 0 8px transparent, 0 0 0 0 ${fade(colors.aquaMain90, 0.7)};
  }
  80%{
    box-shadow: 0 0 0 8px transparent, 0 0 0 4px transparent;
  }
  100%{
    box-shadow: 0 0 0 0 transparent, 0 0 0 4px transparent;
  }
`

const FreeBadge = () => {
  const classes = useStyles()
  return (
    <Chip
      component="span"
      label="Free"
      size="small"
      alt="Free"
      className={classes.styledChip}
    />
  )
}

const useStyles = makeStyles(theme => ({
  styledChip: {
    color: colors.aquaMain30,
    borderColor: colors.aquaMain30,
    backgroundColor: colors.aquaMain90,
    animation: `${pulsingShadow} 2.5s linear infinite`,

    '& > span': {
      padding: theme.spacing(0, 1),
    },
  },
}))

export default FreeBadge
